<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer-receipt/table">客户开票信息列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="选择Excel">
              <CustomerReceiptBatchExcel
                ref="companyExcel"
                :xlsxReqHeader="this.xlsxReqHeader()"
                @getBatchDemo="getBatchDemo"
                @excelFileRemove="excelFileRemove"
                @change-file="(_) => this.file = _"
                @change="(_) => this.form.data = _"
              />
            </el-form-item>

            <el-form-item label="上传进度">
              <div style="margin-top: 8px">
                <el-progress v-if="percentage < 100"
                            :percentage="percentage"
                            :stroke-width="18"
                            color="#666666">
                </el-progress>
                <el-progress v-if="percentage === 100"
                            :percentage="100"
                            :stroke-width="18"
                            status="success">
                </el-progress>
              </div>
            </el-form-item>

            <el-form-item label="错误记录">
              <template>
                <div v-for="(item) in error_data">
                  <span>{{ item }}</span>
                </div>
              </template>
            </el-form-item>

          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">开始上传
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import CustomerReceiptBatchExcel from '../components/CustomerReceiptBatchExcel.vue'

export default {
  components: {CustomerReceiptBatchExcel},
  data () {
    return {
      form: {
        data: [],
      },
      error_data: [],
      percentage: 0,
      file: null,
    }
  },
  computed: {
  },
  watch: {},
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([]),
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs.companyExcel.$refs.CustomerReceiptBatchExcel.clearFiles()
    },
    getBatchDemo () {
      if (this.$route.meta.isUpdate) {
        this.exportUpdateDemo()
      } else {
        this.exportCreateDemo()
      }
    },
    exportCreateDemo () {
      let demo = [{
        'company_name': '上海妙可蓝多食品科技股份有限公司',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'tax_number': '1370000164102345',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4',
      }]
      this.$export('批量添加开票抬头信息 Demo', demo, {fileHeader: this.getDemoHeader(this.xlsxReqHeader())})
    },
    exportUpdateDemo () {
      let demo = [{
        'id': '2',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4',
        'is_disabled': '启用中',
      }, {
        'id': '1',
        'bank_info': '光大银行上海金桥支行76300188000235101',
        'address_phone': '上海市奉贤区工业路899号8幢13839354544',
        'customer_ids': '45646、45644',
        'pay_condition_ids': '1、4',
        'is_disabled': '已禁用',
      }]
      this.$export('批量编辑开票抬头信息 Demo', demo, {fileHeader: this.getDemoHeader(this.xlsxReqHeader())})
    },
    getFormData () {
      return filter.copyJson(this.form.data)
    },
    onSubmit () {
      let data = this.getFormData()
      data = data.map(item => {
        item.attached_file = []
        if (String(item.customer_ids).indexOf('、') !== -1) {
          item.customer_ids = item.customer_ids.split('、')
        } else {
          item.customer_ids = [item.customer_ids]
        }
        if (String(item.pay_condition_ids).indexOf('、') !== -1) {
          item.pay_condition_ids = item.pay_condition_ids.split('、')
        } else {
          item.pay_condition_ids = [item.pay_condition_ids]
        }
        return item
      }).filter(item => item.customer_ids.length)
      if (data.length === 0) {
        this.$message.error('请选择文件')
      } else {
        this.createOrUpdate(data)
      }
    },
    excelFileRemove (fileList) {
      if (fileList.length === 0) {
        this.form.data = []
      }
    },
    async createOrUpdate (data) {
      this.error_data = []
      for (let index = 0; index < data.length; index++) {
        let param = data[index]
        let num = index + 1
        this.percentage = (num / data.length) * 100

        let info = '第' + num + '行 '
        if (this.checkParams(param, info)) {
          try {
            if (this.$route.meta.isUpdate) {
              await request.loading('updateReceiptInfoData', param)
            } else {
              await request.loading('createCustomerReceiptData', param)
            }
          } catch (error) {
            this.error_data.push(info + error.message)
          }
        }
      }
      if (this.error_data.length === 0) {
        this.$confirm('上传成功，是否返回列表查看', '提示', {type: 'warning'}).then(() => {
          this.$router.back()
        })
      }
    },
    checkParams (param, info) {
      let err = ''
      const reqHeader = this.xlsxReqHeader()
      for (const ruleKey in reqHeader) {
        if (param[ruleKey] === '') {
          err = reqHeader[ruleKey].text + ' 为空'
          break
        }
      }
      // 转换请求参数数值
      this.convertParamValue(param, info, err)
      if (err) {
        this.error_data.push(info + err)
        return false
      }
      return true
    },
    convertParamValue (param, info, err) {
      if (param.hasOwnProperty('is_disabled')) {
        if (param.is_disabled === '启用中') {
          param.is_disabled = 0
        } else if (param.is_disabled === '已禁用') {
          param.is_disabled = 1
        } else {
          err = '禁用状态仅支持输入【启用中】、【已禁用】'
        }
      }
    },
    // 返回 excel 文件必须存在的表头字段
    xlsxReqHeader () {
      if (this.$route.meta.isUpdate) {
        return {
          id: {index: null, text: '开票信息ID'},
          bank_info: {index: null, text: '开户银行及账户'},
          address_phone: {index: null, text: '地址及电话'},
          customer_ids: {index: null, text: '使用客户ID'},
          pay_condition_ids: {index: null, text: '账期ID'},
          is_disabled: {index: null, text: '禁用状态'},
        }
      } else {
        return {
          company_name: {index: null, text: '公司名称'},
          bank_info: {index: null, text: '开户银行及账户'},
          address_phone: {index: null, text: '地址及电话'},
          tax_number: {index: null, text: '税号'},
          customer_ids: {index: null, text: '使用客户ID'},
          pay_condition_ids: {index: null, text: '账期ID'},
        }
      }
    },
    getDemoHeader (reqHeader) {
      let demoHeader = []
      for (const key in reqHeader) {
        if (reqHeader.hasOwnProperty(key) && reqHeader[key].hasOwnProperty('text')) {
          demoHeader.push({key, text: reqHeader[key].text})
        }
      }
      return demoHeader
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/customer-receipt/pages/CustomerReceiptBatchForm.vue